import { DashboardWidget } from 'features/widget/types'
import { InsightCount } from 'schemas/action/InsightCountSchema'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { ResolutionOptionsStrings } from 'enums/ResolutionOptions'
import { CountTypeStrings } from 'enums/CountType'

import { CountType, ResolutionOptions, GeoType } from '../../../../../../enums'
import createGeoDataFromInsightSet from './createGeoData'

export const retrieveInsightSet = (widgetData: DashboardWidget<InsightCount>) =>
  widgetData?.data?.[0].results![0].data.insights![0].dataset![0].set

const geoTypeMap = {
  [ResolutionOptions.CITIES]: GeoType.CITY,
  [ResolutionOptions.COUNTRIES]: GeoType.COUNTRY,
  [ResolutionOptions.MARKET_AREAS]: GeoType.DMA,
  [ResolutionOptions.STATES_PROVINCES]: GeoType.STATE
}

export const createGeoData = (
  insightSet: InsightData[],
  resolution: ResolutionOptionsStrings,
  isPerCapita: boolean
) => {
  if (!insightSet) return []

  const filteredInsightSet = insightSet.filter((s) => s.geoType === geoTypeMap[resolution])

  const geoData = createGeoDataFromInsightSet(filteredInsightSet, resolution, isPerCapita)

  return geoData
}

export const getUnit = (isPerCapita: boolean, countType: CountTypeStrings) => {
  const prefix = isPerCapita ? 'Per Capita' : 'Share of'
  let measure = ''
  switch (countType) {
    case CountType.AUTHORS:
      measure = 'Authors'
      break
    case CountType.POSTS:
      measure = 'Posts'
      break
    case CountType.MENTIONS:
    default:
      measure = 'Mentions'
      break
  }
  return `${prefix} ${measure}`
}

const ColorSetting = Object.freeze({
  [CountType.MENTIONS]: 'countType.mentions.gradient',
  [CountType.POSTS]: 'countType.posts.gradient',
  [CountType.AUTHORS]: 'countType.authors.gradient'
})

export const getColorSetting = (countType: CountTypeStrings) => ColorSetting[countType]
